/* React Higher Order Component which fetches end user facing featured demos
    Child (InnerComponent) will only render once channel data is successfully fetched.
    child will receive props: {
        featuredDemos: PropTypes.arrayOf(PropTypes.shape({ ... })),
    }

*/

import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');

const ReactUtil = require('../../util/ReactUtil');
const FeaturedDemoActions = require('../../actions/FeaturedDemoActions');
const FeaturedDemoStore = require('../../stores/FeaturedDemoStore');
import ErrorBox from '../common/ErrorBox';

const propTypes = {
    forceRefreshOnMount: PropTypes.bool, // force refresh of featured demos, even if channel store is already initialized
};

const defaultProps = {
    forceRefreshOnMount: false,
};

export default function withEndUserFeaturedDemos(WrappedComponent) {
    class WithEndUserFeaturedDemos extends React.Component {
        constructor(props) {
            super(props);

            const featuredDemosStoreState = FeaturedDemoStore.getState();
            this.state = {
                featuredDemos: featuredDemosStoreState.featuredDemos,
                initialized: featuredDemosStoreState.initialized,
                getActionId: null,
                fatalError: null,
            };

            this.unsubscribes = [FeaturedDemoStore.listen(this.onFeaturedDemosStoreChange.bind(this))];
        }

        componentDidMount() {
            if (this.props.forceRefreshOnMount || !FeaturedDemoStore.getState().initialized) {
                const getActionId = uuid.v4();
                this.setState({ getActionId: getActionId }, () => {
                    FeaturedDemoActions.getAll(getActionId);
                });
            }
        }

        componentWillUnmount() {
            this.unsubscribes.forEach(u => u());
        }

        onFeaturedDemosStoreChange(newState) {
            let additionalState = {};
            if (newState.action.id === this.state.getActionId) {
                additionalState  = { ...additionalState, getActionId: null };
                if (!!newState.action.error) {
                    additionalState = { ...additionalState, fatalError: newState.action.error };
                }
                
            }

            this.setState({
                initialized: newState.initialized,
                featuredDemos: newState.featuredDemos,
                ...additionalState
            });
        }

        render() {
            if (this.state.fatalError) {
                return <ErrorBox error={this.state.fatalError} allowStackTrace={false}/>;
            }

            if (!this.state.initialized) {
                return null;
            }

            return (
                <WrappedComponent
                    {...this.props}
                    featuredDemos={this.state.featuredDemos}
                />
            );
        }
    }

    WithEndUserFeaturedDemos.propTypes = propTypes;
    WithEndUserFeaturedDemos.defaultProps = defaultProps;
    WithEndUserFeaturedDemos.displayName = `WithEndUserFeaturedDemos(${ReactUtil.getComponentDisplayName(WrappedComponent)})`
    return WithEndUserFeaturedDemos;
}
